import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import gallery4 from "../../../Assets/Gallery/g4.jpg";
import gallery13 from "../../../Assets/Gallery/g13.jpg";
import gallery11 from "../../../Assets/Gallery/g11.jpg";
import gallery10 from "../../../Assets/Gallery/g10.jpg";
import gallery1 from "../../../Assets/Gallery/g1.jpg";
import gallery5 from "../../../Assets/Gallery/g5.jpg";
import "./Gallery.css";

const Gallery = () => {
  return (
    <section className="gallery-wrapper text-white">
      <Container>
        <Row>
          <Col sm={12} className="text-center">
            <div className="section-title">
              <h1>
                Gallery <span>Glimpse</span>
              </h1>
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={6} lg={8} sm={12}>
            <div className="single-item-box">
              <div className="thumbnail">
                <img src={gallery4} alt="" className="img-fluid" />
              </div>
            </div>
          </Col>
          <Col md={6} lg={4} sm={12}>
            <div className="single-item-box">
              <div className="thumbnail">
                <img src={gallery13} alt="" className="img-fluid" />
              </div>
            </div>
          </Col>
          <Col md={6} lg={4} sm={12}>
            <div className="single-item-box">
              <div className="thumbnail">
                <img src={gallery11} alt="" className="img-fluid" />
              </div>
            </div>
          </Col>
          <Col md={6} lg={4} sm={12}>
            <div className="single-item-box">
              <div className="thumbnail">
                <img src={gallery10} alt="" className="img-fluid" />
              </div>
            </div>
          </Col>
          <Col md={6} lg={4} sm={12}>
            <div className="single-item-box">
              <div className="thumbnail">
                <img src={gallery1} alt="" className="img-fluid" />
              </div>
            </div>
          </Col>
          <Col md={6} lg={4} sm={12}>
            <div className="single-item-box">
              <div className="thumbnail">
                <img src={gallery5} alt="" className="img-fluid" />
              </div>
            </div>
          </Col>
          <Col md={6} lg={8} sm={12}>
            <div className="single-item-box">
              <div className="thumbnail">
                <img src={gallery4} alt="" className="img-fluid" />
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Gallery;
